export default __webpack_public_path__ + "static/media/cranium_crusher_xmas.24e43697.png";